import React, { PureComponent, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import FormControl from "@material-ui/core/FormControl";
import CardContent from "@material-ui/core/CardContent";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import SearchIcon from "@material-ui/icons/Search";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import InputLabel from "@material-ui/core/InputLabel";
import LaunchIcon from "@material-ui/icons/Launch";
import LastPageIcon from "@material-ui/icons/LastPage";
import InputBase from "@material-ui/core/InputBase";
import { alpha } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { axios } from "../../utils/axiosConfig";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ConfirmedSnackBar from "../../utils/ConfirmedSnackbar";
import { UserContextData, UserContext } from "../../Contexts/userContext";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import JobDetail from "./JobDetail";
import TablePagination from "@material-ui/core/TablePagination";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";

import TableHead from "@material-ui/core/TableHead";

import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import Switch from "@material-ui/core/Switch";
import Chip from "@material-ui/core/Chip";
import SaveIcon from "@material-ui/icons/Save";
import moment from "moment-timezone";
import Card from "@material-ui/core/Card";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import {
  setJobConfiguration,
  setOperators,
  setJobItems,
  resetConfiguration,
} from "../../Features/createJobConfigurationSlice";
const styles = {
  textField: {
    // width: "100%",
    marginLeft: "5px",
    marginRight: "5px",
  },
  selectFeild: {
    width: "15%",
    marginTop: "15px",
    marginLeft: "5px",
    marginRight: "5px",
  },
  grid: {
    padding: "16px",
  },
  tableHeadFull: {
    width: "100%",
  },
  datePicker: {
    selectColor: "black",
  },
  priceTextFeild: {
    margin: "26px",
  },
  jobCardPrice: {
    color: "#fff",
    fontSize: "52px",
    marginTop: "7px",
    marginBottom: "7px",
  },
  formControl: {
    width: "65%",
  },
  center: {
    margin: "auto",
    width: "fit-content",
  },
  search: {
    position: "relative",
    borderRadius: "4px",
    backgroundColor: alpha("#fff", 0.15),
    "&:hover": {
      backgroundColor: alpha("#fff", 0.25),
    },
    // marginLeft: 0,
    width: "250px",
    marginLeft: "auto",
  },
  searchIcon: {
    padding: "16px",
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: "8px, 8px, 8px, 8px",
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + 32px)`,
    width: "100%",
  },
  card: {
    width: "100%",
    backgroud: "#000; !important",
  },
  jobCardTitle: {
    marginTop: "10px",
    color: "#fff",
  },
  titleDiv: {
    display: "flex",
  },
  switchGrid: {
    margin: "auto",
    display: "flex",
  },
  switchClass: {
    margin: "3px 10px 5px 10px",
  },
  timeContainer: {
    margin: "43px 0px 0px 0px",
  },
  rootCard: {
    background: "#000",
    width: "100%",
    marginRight: "80px",
  },
  showCircularProgressStyle: {
    margin: "auto",
    width: "fit-content",
    padding: "50%",
  },

  tableHeading: {
    padding: "15px",
    fontSize: "20px",
    color: "#fff",
    display: "flex",
    background: "#000;",
  },
  tableBold: {
    fontWeight: 600,
    fontSize: "17px",
    color: "#000;",
  },

  gridHere: {
    // borderRight:"1px solid #000;"
  },

  editIcon: {
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    // marginLeft: "20px",
    // marginBottom: "15px"
  },

  expandIcon: {
    color: "#fff",
    fontSize: "20px",
    cursor: "pointer",
    // marginLeft: "20px",
    // marginBottom: "15px"
  },
  launchIcon: {
    color: "#000;",
    cursor: "pointer",
  },
  oilIcons: {
    fontSize: "40px",
    color: "#fff",
    margin: "4px 4px",
  },
  priceIcons: {
    fontSize: "50px",
    color: "#fff",
    margin: "4px 4px",
  },
  editIconChip: {
    fontSize: "16px",
    cursor: "pointer",
  },
  tableCellClass: {
    display: "inline-flex",
  },
  inputFeildHovered: {
    color: "#fff",
    fontSize: "16px",
    width: "380px",
    background: "none",
    textAlign: "center",
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        display: "none",
      },
  },
  inputFeild: {
    color: "#000;",
    fontSize: "16px",
    width: "380px",
    background: "none",
    textAlign: "center",
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        display: "none",
      },
  },
  inputFeildHaulage: {
    color: "#000;",
    fontSize: "20px",
    background: "none",
    width: "40px",
    textAlign: "center",
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        display: "none",
      },
  },
  inputFeildHaulageHovered: {
    color: "#fff",
    fontSize: "20px",
    background: "none",
    width: "40px",
    textAlign: "center",
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        display: "none",
      },
  },

  startAutoJob: {
    color: "#fff",
    background: "#000;",
    width: "auto",
    height: "53px",
    marginTop: "17px",
    marginLeft: "10px",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#000;",
      color: "#fff",
    },
  },
  startCron: {
    marginLeft: "auto",
    marginTop: "auto",
    marginBottom: "auto",
  },
  tablePagination: {
    marginLeft: "auto",
  },
  enabledChip: {
    backgroudColor: "green",
  },
  disabledChip: {
    backgroud: "red",
  },
  "& .MuiTablePagination-toolbar": {
    marginLeft: "auto",
  },
  tableFooter: {
    width: "fit-content",
    marginTop: "20px",
    marginLeft: "auto",
  },
  circularProgress: {
    marginLeft: "10px",
  },
  circularProgressCenter: {
    margin: "auto",
  },
  autoCircularProgress: {
    margin: "auto",
  },
  circularStyle: {
    width: "100%",
    margin: "auto",
    marginTop: "15%",
    marginBottom: "15%",
  },
  circularProgressBase: {
    width: "100%",
  },
  snackbar: {
    backgroundColor: "rgb(50, 50, 50)",
  },
  fullWidth: {
    width: "100%",
  },
  close: {
    color: "#fff",
  },
  menuButtonsIconPrimary: {
    marginLeft: "auto",
    color: "#fff",
    cursor: "pointer",
    // height: "50px"
  },
  dialogContent: {
    margin: "10px",
  },
  newCronTimePicker: {
    marginTop: "15px",
  },
  headerStyle: {
    display: "flex",
    width: "100%",
  },
  autoComplete: {
    width: "20%",
    marginRight: "10px",
    marginTop: "15px",
    /* display: flex; */

    display: "inline-flex",
    position: "relative",
    minWidth: 0,
    flexDirection: "column",
    verticalAlign: "top",
  },
  subHeading: {
    fontSize: "15px",
    fontWeight: 600,
  },
  noDataFoundText: {
    color: "#000",
    fontSize: "1rem",
    marginBottom: "7px",
    marginTop: "7px",
    margin: "auto",
    textAlign: "center",
    fontWeight: "600",
    // letterSpacing: "0.1rem",
    lineHeight: 1.5,
  },
};
function StartIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="m273.318 261.626c1.726 4.465 2.682 9.308 2.682 14.374 0 22.056-17.944 40-40 40s-40-17.944-40-40 17.944-40 40-40c2.111 0 4.184.167 6.208.484l62.233-77.051c6.94-8.593 19.533-9.933 28.125-2.992 8.593 6.94 9.932 19.532 2.992 28.125zm-25.504 210.024c-3.907.232-7.882.35-11.814.35-108.075 0-196-87.925-196-196s87.925-196 196-196c106.13 0 194.041 86.294 195.967 192.363.201 11.043 9.323 19.832 20.36 19.633 11.044-.201 19.834-9.316 19.633-20.36-1.128-62.122-26.174-120.344-70.523-163.942-39.619-38.947-90.663-62.266-145.437-66.844v-20.85c0-11.046-8.954-20-20-20s-20 8.954-20 20v20.847c-55.494 4.627-107.051 28.449-146.877 68.275-44.575 44.575-69.123 103.84-69.123 166.878s24.548 122.303 69.123 166.877c44.574 44.575 103.839 69.123 166.877 69.123 4.72 0 9.493-.141 14.186-.42 11.026-.655 19.434-10.124 18.779-21.15s-10.12-19.435-21.151-18.78zm124.41-422.262 53.954 44.796c3.735 3.101 8.263 4.613 12.765 4.613 5.743 0 11.443-2.461 15.398-7.225 7.056-8.499 5.887-21.107-2.612-28.164l-53.954-44.796c-8.499-7.056-21.108-5.887-28.164 2.612-7.054 8.499-5.885 21.108 2.613 28.164zm-339.166 49.409c4.442 0 8.913-1.473 12.625-4.499l54.954-44.796c8.562-6.979 9.844-19.577 2.865-28.139s-19.577-9.845-28.139-2.865l-54.954 44.796c-8.562 6.979-9.844 19.577-2.865 28.139 3.953 4.85 9.709 7.364 15.514 7.364zm478.942 293.203c0 12.547-6.401 23.93-17.124 30.449l-138.721 84.339c-5.672 3.449-12.093 5.18-18.518 5.18-6.021 0-12.045-1.519-17.468-4.568-11.207-6.302-18.169-18.204-18.169-31.061v-168.678c0-12.857 6.962-24.759 18.169-31.061 11.208-6.303 24.999-6.069 35.986.612l138.721 84.339c10.723 6.519 17.124 17.902 17.124 30.449zm-44.038 0-125.962-76.583v153.165z" />
      </svg>
    </SvgIcon>
  );
}
function OilIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
        <g id="001---Oil-Barrel" fill="rgb(255,255,255)">
          <path
            id="Shape"
            d="m0 56.5c0 1.9329966 1.56700338 3.5 3.5 3.5h35c1.8354698-.0003687 3.3588662-1.4185956 3.4903106-3.2493528.1314444-1.8307571-1.1737199-3.4520686-2.9903106-3.7146472v-5.072c1.7216859-.2488609 2.9992965-1.7244213 2.9992965-3.464s-1.2776106-3.2151391-2.9992965-3.464v-17.072c1.7216859-.2488609 2.9992965-1.7244213 2.9992965-3.464s-1.2776106-3.2151391-2.9992965-3.464v-5.072c1.8165907-.2625786 3.121755-1.8838901 2.9903106-3.71464723-.1314444-1.83075716-1.6548408-3.24898409-3.4903106-3.24935277h-21.5v-2c0-1.65685425-1.3431458-3-3-3h-6c-1.65685425 0-3 1.34314575-3 3v2h-1.5c-1.83546977.00036868-3.35886622 1.41859561-3.49031059 3.24935277-.13144437 1.83075713 1.17371986 3.45206863 2.99031059 3.71464723v5.072c-1.7216859.2488609-2.99929649 1.7244213-2.99929649 3.464s1.27761059 3.2151391 2.99929649 3.464v17.072c-1.7216859.2488609-2.99929649 1.7244213-2.99929649 3.464s1.27761059 3.2151391 2.99929649 3.464v5.072c-1.72196531.2485443-2.99994949 1.72419-3 3.464zm7-53.5c0-.55228475.44771525-1 1-1h6c.5522847 0 1 .44771525 1 1v2h-8zm-3.5 52h.5c.55228475 0 1-.4477153 1-1v-6h3c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-4.5c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5h9.5c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-8v-17h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9.5c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5h25.5c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-24v-5h23c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-24.5c-.82842712 0-1.5-.67157288-1.5-1.5s.67157288-1.5 1.5-1.5h35c.8284271 0 1.5.67157288 1.5 1.5s-.6715729 1.5-1.5 1.5h-.5c-.5522847 0-1 .4477153-1 1v6h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h4.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-9.5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8v17h-8c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h9.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-25.5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h24v5h-23c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h24.5c.8284271 0 1.5.6715729 1.5 1.5s-.6715729 1.5-1.5 1.5h-35c-.82842712 0-1.5-.6715729-1.5-1.5s.67157288-1.5 1.5-1.5z"
          />
          <path
            id="Shape"
            d="m20.182 41.954c.2656246.0298381.5327048.0448614.8.045 1.8594589.0047815 3.6444122-.7304677 4.9610336-2.0435246s2.0567069-3.0960103 2.0569664-4.9554754c0-5.022-3.843-9.423-5.493-11.312-.3792756-.4363766-.9288357-.6872706-1.507-.688-.5749518-.0005887-1.1220011.2477717-1.5.681l-.076.087c-1.617 1.85-4.981 5.7-5.383 10.335-.3880803 3.8399307 2.3206264 7.3028939 6.141 7.851zm.747-16.87.08-.071c1.491 1.71 4.991 5.716 4.991 9.987-.0001549 1.4251147-.6084245 2.7824436-1.672 3.731-1.0656353.9601418-2.4954214 1.4107123-3.919 1.235-2.748379-.416716-4.6791537-2.9266791-4.377-5.69.346-3.986 3.42-7.502 4.897-9.192z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
function PriceIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
        <g fill="rgb(255,255,255)">
          <path d="m472 392h-32v-232c0-4.417969-3.582031-8-8-8h-48c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h40v224h-112c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h152v24c0 13.253906-10.746094 24-24 24h-400c-13.253906 0-24-10.746094-24-24v-24h160v16c0 4.417969 3.582031 8 8 8h112c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-104v-16c0-4.417969-3.582031-8-8-8h-128v-224h40c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-48c-4.417969 0-8 3.582031-8 8v232h-32c-4.417969 0-8 3.582031-8 8v32c0 22.089844 17.910156 40 40 40h400c22.089844 0 40-17.910156 40-40v-32c0-4.417969-3.582031-8-8-8zm0 0" />
          <path d="m96 200c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-16c-4.417969 0-8 3.582031-8 8v176c0 4.417969 3.582031 8 8 8h320c4.417969 0 8-3.582031 8-8v-176c0-4.417969-3.582031-8-8-8h-16c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h8v160h-304v-160zm0 0" />
          <path d="m264 336c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-72c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0" />
          <path d="m136 328c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0" />
          <path d="m168 328c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0" />
          <path d="m304 328c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0" />
          <path d="m336 328c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0" />
          <path d="m368 328c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0" />
          <path d="m128 296h224c4.417969 0 8-3.582031 8-8v-184c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v176h-208v-264h208v56c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-64c0-4.417969-3.582031-8-8-8h-224c-4.417969 0-8 3.582031-8 8v280c0 4.417969 3.582031 8 8 8zm0 0" />
          <path d="m184 128c-6.628906 0-12-5.371094-12-12 0-4.417969-3.582031-8-8-8s-8 3.582031-8 8c.050781 12.339844 8.171875 23.195312 20 26.71875v9.28125c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-9.28125c13.367188-3.902344 21.8125-17.058594 19.800781-30.839844-2.015625-13.777344-13.875-23.964844-27.800781-23.878906-6.628906 0-12-5.371094-12-12s5.371094-12 12-12 12 5.371094 12 12c0 4.417969 3.582031 8 8 8s8-3.582031 8-8c-.050781-12.339844-8.171875-23.195312-20-26.71875v-9.28125c0-4.417969-3.582031-8-8-8s-8 3.582031-8 8v9.28125c-13.367188 3.902344-21.8125 17.058594-19.800781 30.839844 2.015625 13.777344 13.875 23.964844 27.800781 23.878906 6.628906 0 12 5.371094 12 12s-5.371094 12-12 12zm0 0" />
          <path d="m320 48h-48c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h48c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0" />
          <path d="m312 160c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-72c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0" />
          <path d="m320 112h-80c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h80c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0" />
          <path d="m320 80h-72c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h72c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0" />
          <path d="m152 192v64c0 4.417969 3.582031 8 8 8h160c4.417969 0 8-3.582031 8-8v-64c0-4.417969-3.582031-8-8-8h-160c-4.417969 0-8 3.582031-8 8zm160 56h-96v-48h96zm-144-48h32v48h-32zm0 0" />
        </g>
      </svg>
    </SvgIcon>
  );
}
function GasIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
        <g id="034---Gas-Canister" fill="rgb(255,255,255)">
          <path
            id="Shape"
            d="m7.457 23.853c.24226616.1081499.51757993.1155935.76533594.0206922.24775601-.0949012.44764466-.2843678.55566406-.5266922 1.19166156-2.6653285 3.5967073-4.5914506 6.458-5.172.5415152-.1088001.8923001-.6359848.7835-1.1775s-.6359848-.8923001-1.1775-.7835c-3.4957549.7087308-6.43421252 3.0617315-7.89 6.318-.10821287.2421421-.11580079.5173546-.02109444.7650914s.28394877.4477037.52609444.5559086z"
          />
          <path
            id="Shape"
            d="m31.867 25.143c-.6822683-5.6364659-4.5085162-10.3953303-9.867-12.272v-1.871c-.0052514-1.26678543-.8056491-2.39374545-2-2.816v-2.184c1.6568542 0 3-1.34314575 3-3s-1.3431458-3-3-3h-6c-1.6568542 0-3 1.34314575-3 3s1.3431458 3 3 3v2.184c-1.1943509.42225455-1.9947486 1.54921457-2 2.816v1.88c-5.33580908 1.9019535-9.14892 6.642536-9.863 12.262-1.26448495.3774001-2.13259737 1.538404-2.137 2.858v1c.00525139 1.2667854.80564914 2.3937454 2 2.816v16.368c-1.19435086.4222546-1.99474861 1.5492146-2 2.816v1c.00525139 1.2667854.80564914 2.3937454 2 2.816v2.184c0 1.6568542 1.34314575 3 3 3h24c1.6568542 0 3-1.3431458 3-3v-2.184c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-16.368c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c-.0043109-1.3181252-.8704519-2.4782587-2.133-2.857zm-18.867-22.143c0-.55228475.4477153-1 1-1h6c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-6c-.5522847 0-1-.44771525-1-1zm5 3v2h-2v-2zm-4 5c0-.5522847.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1v1.3c-.9874935-.199793-1.9924978-.3002935-3-.3-1.0079237.0013583-2.0130959.1052261-3 .31zm3 3c6.4074879-.0032661 11.8594964 4.6678215 12.839 11h-25.674c.99806865-6.3201996 6.4365074-10.9811132 12.835-11zm12 44h-24c-.55228475 0-1-.4477153-1-1v-2h26v2c0 .5522847-.4477153 1-1 1zm3-29c0 .5522847-.4477153 1-1 1h-9c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8v16h-5c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h6c.5522847 0 1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1h-28c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1h6c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-5v-16h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1h28c.5522847 0 1 .4477153 1 1z"
          />
          <path
            id="Shape"
            d="m20.24 36.036-.291-.274c-.4122049-.364585-.6715057-.8714003-.726-1.419-.01-.1-.016-.193-.019-.289l-.052-2.079c-.0103555-.402297-.260854-.7591897-.6356786-.9056704-.3748247-.1464806-.8009352-.0540054-1.0813214.2346704l-1.416 1.462c-.142.146-.287.289-.454.453-.4025954.3814587-.7803674.7882901-1.131 1.218-.9743603 1.0504831-1.3507182 2.5227954-1 3.912.1218908.375707.2919749.7340265.506 1.066.1397361.202896.2463954.4266779.316.663.027.131-.013.172-.031.191-.056.056-.149.089-.343.082-.1780538-.0514778-.3361165-.1561551-.453-.3l-1.045-1.187c-.2433479-.276433-.6189419-.3967365-.9776109-.3131306-.3586689.0836058-.642355.3575876-.7383891.7131306l-.42 1.551c-.58582979 1.9586496-.1944009 4.0795094 1.052 5.7.9660099 1.0845451 2.240153 1.8482634 3.652 2.189.7546563.1942028 1.5307563.2926431 2.31.293 2.1631497.1020677 4.2457635-.8313769 5.609-2.514 1.015367-1.4191145 1.3669121-3.2082021.964-4.906-.2726154-1.0980964-.7363547-2.1396482-1.37-3.077-.6415708-.906469-1.3884615-1.7335874-2.225-2.464zm1.025 9.264c-.990403 1.1660744-2.4731183 1.7962284-4 1.7-.607201.0000028-1.2119764-.0766021-1.8-.228-1.012632-.2368669-1.929641-.7752174-2.63-1.544-.7811446-1.0450317-1.0419093-2.3897376-.708-3.651.3613408.351678.8101938.6002735 1.3.72.8037536.1855412 1.6465664-.0528911 2.234-.632.5069926-.525498.71722-1.2699281.56-1.983-.1092944-.460708-.2992203-.8984515-.561-1.293-.122549-.1879078-.2232032-.3892161-.3-.6-.1486424-.768928.0950269-1.5614154.65-2.114.2993386-.3623341.6209616-.7056659.963-1.028l.251-.248c0 .054.009.107.014.16.1058596 1.0207736.583099 1.9670672 1.341 2.659l.3.282c.7209177.6240202 1.3657065 1.3309047 1.921 2.106.5043804.7414875.8740417 1.5661164 1.092 2.436.2712671 1.1255883.0426559 2.3134917-.627 3.258z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

function TargetIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 505.262 505.262" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M431.268,73.994C383.552,26.279,320.111,0,252.631,0S121.71,26.279,73.994,73.994S0,185.151,0,252.631   c0,27.957,4.538,55.427,13.487,81.646c1.338,3.92,5.604,6.013,9.521,4.675c3.92-1.338,6.013-5.601,4.675-9.521   C19.268,304.776,15,278.936,15,252.631c0-63.474,24.718-123.148,69.601-168.03C129.483,39.718,189.157,15,252.631,15   s123.147,24.718,168.03,69.6c44.883,44.883,69.601,104.557,69.601,168.03c0,63.473-24.718,123.147-69.601,168.03   c-44.883,44.882-104.557,69.6-168.03,69.6c-45.233,0-89.227-12.755-127.222-36.888c-36.995-23.496-66.764-56.655-86.088-95.894   c-1.831-3.716-6.327-5.246-10.042-3.415c-3.716,1.83-5.245,6.326-3.415,10.042c20.542,41.709,52.183,76.956,91.502,101.929   c40.404,25.662,87.179,39.226,135.265,39.226c67.48,0,130.921-26.278,178.637-73.994c47.716-47.716,73.994-111.157,73.994-178.637   S478.983,121.71,431.268,73.994z" />
          <path d="M352.199,100.135c-29.639-19.415-64.068-29.677-99.568-29.677c-100.451,0-182.175,81.723-182.175,182.173   c0,100.451,81.724,182.173,182.175,182.173s182.174-81.723,182.174-182.173c0-49.028-19.267-95.05-54.251-129.588   c-2.947-2.909-7.696-2.88-10.606,0.068c-2.91,2.948-2.88,7.696,0.067,10.606c32.107,31.698,49.79,73.929,49.79,118.914   c0,92.18-74.994,167.173-167.174,167.173c-92.181,0-167.175-74.994-167.175-167.173c0-92.179,74.994-167.173,167.175-167.173   c32.571,0,64.16,9.414,91.35,27.225c3.461,2.269,8.112,1.301,10.383-2.164C356.634,107.054,355.664,102.405,352.199,100.135z" />
          <path d="M252.631,140.915c-61.601,0-111.717,50.115-111.717,111.715s50.116,111.716,111.717,111.716   s111.716-50.116,111.716-111.716S314.231,140.915,252.631,140.915z M252.631,349.346c-53.33,0-96.717-43.387-96.717-96.716   s43.387-96.715,96.717-96.715c53.329,0,96.716,43.386,96.716,96.715S305.96,349.346,252.631,349.346z" />
          <path d="M261.698,242.582v-26.824c4.827,0.67,7.996,2.26,10.588,3.576c2.137,1.085,3.824,1.942,5.734,1.942   c6.094,0,8.73-7.427,8.73-11.215c0-4.181-3.397-7.592-9.825-9.867c-5.454-1.929-11.575-2.585-15.228-2.808V187.19   c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5v5.972c-0.037,0.195-0.063,0.393-0.063,0.594v3.911   c-9.411,1.308-30.127,6.901-30.127,30.72c0,20.15,15.934,26.256,30.127,31.561v29.991c-7.52-1.001-12.195-4.644-15.97-7.584   c-2.867-2.233-5.132-3.998-7.756-3.998c-5.247,0-9.196,6.898-9.196,11.371c0,8.858,14.046,19.105,32.922,19.742v3.863   c0,0.202,0.026,0.399,0.063,0.594v4.145c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5v-9.409   c17.729-3.541,27.849-15.498,27.849-33.067C289.547,255.503,276.053,248.07,261.698,242.582z M261.698,265.486   c4.411,2.472,7.902,5.933,7.902,12.128c0,5.343-2.781,9.247-7.902,11.261V265.486z M248.698,237.723   c-6.516-2.761-10.243-5.706-10.243-11.355c0-5.024,3.622-8.544,10.243-10.036V237.723z" />
        </g>
      </svg>
    </SvgIcon>
  );
}

class JobList extends PureComponent {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      openSnackbar: false,
      snackBarMessage: null,
      showCircularProgress: false,

      tableColumns: [
        {
          field: "jobID",
          title: "DYNO Ref ",
        },
        // {
        //   field: "customerAccountRef",
        //   title: "Customer Account Ref"
        // },

        {
          field: "customerName",
          title: "Customer Name",
        },
        {
          field: "deliveryBy",
          title: "Complete By",
        },
        {
          field: "deliveryByTime",
          title: "Complete By Time",
        },
        {
          field: "invoiceNumber",
          title: "Invoice Number",
        },
        {
          field: "itemsSummary",
          title: "Service Summary",
        },

        {
          field: "operatorName",
          title: "Operator Name",
        },
        {
          field: "orderNumber",
          title: "Order Number",
        },
        // {
        //   field: "product",
        //   title: "Product"
        // },
        // {
        //   field: "quantity",
        //   title: "Quantity"
        // },
        {
          field: "status",
          title: "Status",
        },

        {
          field: "action",
          title: "Details",
        },
      ],
      totalPages: 1,
      filters: "",
      filterPage: 1,
      pageSize: 50,
      status: "",
      sortBy: "",
      deliveryBy: moment().subtract(6, "days"),
      // deliveryBy: moment(),
      deliveryFrom: moment().add(1, "days"),
      // deliveryFrom: moment(),
      jobID: "",
      customerAccountRef: "",
      orderNumber: "",
      invoiceNumber: "",
      driverName: "",
      driverID: "",
      customerName: "",
      product: "",
      quantity: "",
      vehicleRegNo: "",
      jobListData: [],
      jobListFilteredData: [],
      allDrivers: [],
      allProducts: [],
      allVehicles: [],

      jobDetailView: false,
      selectedJob: {},
    };
  }

  componentDidMount() {
    this.jobList(1);
    this.getAllDrivers();
    this.getAllProducts();
    // this.getAllVehicles();
  }

  jobList = (pageNumber) => {
    const { logoutUser } = this.props;
    this.setState({ showCircularProgress: true });
    const {
      filterPage,
      pageSize,
      status,
      deliveryBy,
      deliveryFrom,
      jobID,
      customerAccountRef,
      orderNumber,
      invoiceNumber,
      driverName,
      driverID,
      sortBy,
      customerName,
      product,
      quantity,
      vehicleRegNo,
    } = this.state;

    console.log(product, "productHere");
    let url = `jobs?page=${pageNumber}&size=${pageSize}${
      jobID !== "" ? `&jobID=${jobID}` : ""
    }${
      customerAccountRef !== ""
        ? `&customerAccountRef=${customerAccountRef}`
        : ""
    }${
      orderNumber !== ""
        ? `&orderNumber=${encodeURIComponent(orderNumber)}`
        : ""
    }${customerName !== "" ? `&customerName=${customerName}` : ""}${
      deliveryBy !== ""
        ? `&dateFrom=${moment(deliveryBy)
            .tz("Europe/London")
            .format("YYYY-MM-DD")}`
        : ""
    }${
      deliveryFrom !== ""
        ? `&dateTo=${moment(deliveryFrom)
            .tz("Europe/London")
            .format("YYYY-MM-DD")}`
        : ""
    }${driverID !== "" ? `&operatorID=${driverID}` : ""}${
      invoiceNumber !== "" ? `&invoiceNumber=${invoiceNumber}` : ""
    }${product !== "" ? `&product=${encodeURIComponent(product)}` : ""}${
      quantity !== "" ? `&quantity=${quantity.toString()}` : ""
    }${status !== "" ? `&status=${status}` : ""}${
      vehicleRegNo !== "" ? `&vehicleRegNo=${vehicleRegNo}` : ""
    }${sortBy !== "" ? `&sortBy=${sortBy}` : ""}`;

    console.log("sadas", "reshere");

    axios
      .get(url)
      .then((res) => {
        let response = res.data;
        console.log(res, "reshere");
        if (response.success === true) {
          this.setState({ totalPages: response.data.totalPages });
          this.setState({
            jobListData: response.data.jobs,
            jobListFilteredData: response.data.jobs,
          });
        } else {
          this.setState({ totalPages: 1 });
          this.setState({
            jobListData: [],
            jobListFilteredData: [],
          });
        }
        this.setState({ showCircularProgress: false });
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          logoutUser();
        }
      });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleDriverChange = (event, value) => {
    console.log(value, "event");
    if (value !== null) {
      this.setState({ driverName: value.driverName });
      this.setState({ driverID: value.driverID });
    } else {
      this.setState({ driverName: "", driverID: "" });
    }
  };
  handleProductChange = (event, value) => {
    console.log(value, "event");
    if (value !== null) {
      this.setState({ product: value });
    } else {
      this.setState({ product: "" });
    }
  };
  handleVehicleRegChange = (event, value) => {
    if (value !== null) {
      this.setState({ vehicleRegNo: value });
    } else {
      this.setState({ vehicleRegNo: "" });
    }
  };
  handleByDateChange = (date) => {
    console.log("pageChange", date);
    this.setState({ deliveryBy: date });
  };
  handleFromDateChange = (date) => {
    console.log("pageChange", date);
    this.setState({ deliveryFrom: date });
  };
  handlePageChange = (event, pageNumber) => {
    console.log("pageChange", pageNumber);
    this.jobList(pageNumber);
    this.setState({ filterPage: pageNumber });
  };
  searchJob = () => {
    this.jobList(1);
  };

  handleSearch = (event) => {
    let data = this.state.jobListData;
    console.log(data, "datadatadatadata");
    const newData = data.filter((item) => {
      if (!event.target.value) {
        return item;
      }
      if (item.jobID.toString().includes(event.target.value)) {
        return item;
      }
    });
    this.setState({ jobListFilteredData: newData });
  };
  getAllDrivers = () => {
    const { logoutUser } = this.props;
    const url = `job/driver/all`;
    axios
      .get(url)
      .then((res) => {
        let response = res.data;
        if (response.success === true) {
          this.setState({ allDrivers: response.data });
        } else {
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          logoutUser();
        }
      });
  };
  getAllProducts = () => {
    const { logoutUser } = this.props;
    const url = `job/product/all`;
    axios
      .get(url)
      .then((res) => {
        let response = res.data;
        if (response.success === true) {
          this.setState({ allProducts: response.data });
        } else {
        }
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          logoutUser();
        }
      });
  };
  getAllVehicles = () => {
    // const { logoutUser } = this.props;
    // const url = `job/vehicle/all`;
    // axios
    //   .get(url)
    //   .then(res => {
    //     let response = res.data;
    //     if (response.success === true) {
    //       this.setState({ allVehicles: response.data });
    //     } else {
    //     }
    //   })
    //   .catch(function(error) {
    //     if (error.response.status === 403) {
    //       logoutUser();
    //     }
    //   });
  };
  jobDetailBack = () => {
    this.setState({ jobDetailView: false });
  };
  //   startAutoJob=()=>{
  //     this.setState({ currentRunningJob: true });
  //     let url = "/start/automated/job";
  //     axios.post(url).then(res => {
  //       let response = res.data;
  //       if (response.success === true) {
  //         this.setState({ currentRunningJob: true });
  //         this.showSnackBar(response.message);
  //       } else {
  //         this.setState({ currentRunningJob: false });
  //         this.showSnackBar(response.message);
  //         // this.setState({jobStages:})
  //       }
  //     });
  //   }

  handleJobDetailView = (row) => {
    this.setState({ jobDetailView: true, selectedJob: row });
  };

  showSnackBar = (message) => {
    this.setState({ openSnackbar: true, snackBarMessage: message });
  };
  handleSnackBarClose = () => {
    this.setState({ openSnackbar: false });
  };

  render() {
    const { classes } = this.props;
    const {
      openSnackbar,
      snackBarMessage,

      totalPages,
      tableColumns,
      jobListData,
      litres,
      postCode,
      litre,
      productType,
      onlinePrice,
      targetPrice,
      errorPostCode,
      errorLitre,
      deliveryFrom,
      deliveryBy,
      showCircularProgress,
      jobDetailView,
      selectedJob,
      jobListFilteredData,
      allDrivers,
      allProducts,
      allVehicles,
    } = this.state;
    return (
      <>
        {!jobDetailView && (
          <>
            <Grid
              className={classes.grid}
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <div className={classes.headerStyle}>
                <h1>Jobs</h1>
              </div>
              {/* <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.tableHeading}
                >
                  <div>
                    <Typography>Job Filters</Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails> */}
              <Grid
                className={classes.grid}
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <div className={classes.subHeading}>Job Filters</div>
                <Grid item xs={12} md={12}>
                  {/* <TextField
                        value={this.state.jobID}
                        name="jobID"
                        label="JOB ID"
                        className={classes.textField}
                        margin="normal"
                        onChange={this.handleChange}
                        variant="outlined"
                        // error={errorFirstName}
                      /> */}
                  {/* <TextField
                        value={this.state.customerAccountRef}
                        name="customerAccountRef"
                        label="CustomerAccountRef"
                        className={classes.textField}
                        margin="normal"
                        onChange={this.handleChange}
                        variant="outlined"
                        // error={errorFirstName}
                      /> */}
                  <TextField
                    value={this.state.jobID}
                    name="jobID"
                    label="DYNO Ref"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange}
                    variant="outlined"
                    // error={errorFirstName}
                  />
                  <TextField
                    value={this.state.orderNumber}
                    name="orderNumber"
                    label="Order Number"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange}
                    variant="outlined"
                    // error={errorFirstName}
                  />
                  <TextField
                    value={this.state.customerName}
                    name="customerName"
                    label="Customer Name"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange}
                    variant="outlined"
                    // error={errorFirstName}
                  />
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Select Date"
                      value={deliveryBy}
                      onChange={this.handleByDateChange}
                      name="deliverBy"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      className={classes.textField}
                    />
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Date To"
                      name="deliveryFrom"
                      value={deliveryFrom}
                      onChange={this.handleFromDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      className={classes.textField}
                    />
                  </MuiPickersUtilsProvider>

                  <Autocomplete
                    className={classes.autoComplete}
                    name="driverName"
                    options={allDrivers}
                    getOptionLabel={(option) => option.driverName}
                    onChange={(event, value) =>
                      this.handleDriverChange(event, value)
                    }
                    renderInput={(params) => (
                      <TextField
                        value={this.state.driverName}
                        className={classes.textField}
                        {...params}
                        label="Operator Name"
                        variant="outlined"
                      />
                    )}
                  />

                  {/* <Autocomplete
                    className={classes.autoComplete}
                    name="vehicleRegNo"
                    options={allVehicles}
                    getOptionLabel={option => option}
                    onChange={(event, value) =>
                      this.handleVehicleRegChange(event, value)
                    }
                    renderInput={params => (
                      <TextField
                        value={this.state.vehicleRegNo}
                        className={classes.textField}
                        {...params}
                        label="Vehicle Reg No"
                        variant="outlined"
                      />
                    )}
                  /> */}
                  <TextField
                    value={this.state.invoiceNumber}
                    name="invoiceNumber"
                    label="Invoice Number"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange}
                    variant="outlined"
                    // error={errorFirstName}
                  />
                  <>
                    <TextField
                      value={this.state.product}
                      name="product"
                      label="Product"
                      className={classes.textField}
                      margin="normal"
                      onChange={this.handleChange}
                      variant="outlined"
                      // error={errorFirstName}
                    />

                    {/* <Autocomplete
                      className={classes.autoComplete}
                      name="product"
                      options={allProducts}
                      getOptionLabel={option => option}
                      onChange={(event, value) =>
                        this.handleProductChange(event, value)
                      }
                      renderInput={params => (
                        <TextField
                          value={this.state.product}
                          className={classes.textField}
                          {...params}
                          label="Product"
                          variant="outlined"
                        />
                      )}
                    /> */}
                  </>

                  {/* <TextField
                    value={this.state.quantity}
                    name="quantity"
                    label="Quantity"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.handleChange}
                    variant="outlined"
                    // error={errorFirstName}
                  /> */}
                  <FormControl
                    variant="outlined"
                    className={classes.selectFeild}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={this.state.status}
                      name="status"
                      onChange={this.handleChange}
                      label="status"
                    >
                      <MenuItem value="">
                        <em>All</em>
                      </MenuItem>
                      <MenuItem value={"Recorded"}>Recorded</MenuItem>
                      <MenuItem value={"Awaiting Operator Receipt"}>
                        Awaiting Operator Receipt
                      </MenuItem>
                      <MenuItem value={"Received By Operator"}>
                        Received By Operator
                      </MenuItem>
                      <MenuItem value={"Amendments Submitted"}>
                        Amendments Submitted
                      </MenuItem>
                      <MenuItem value={"Work Commenced"}>
                        Work Commenced
                      </MenuItem>
                      <MenuItem value={"Completed and Signed Off"}>
                        Completed and Signed Off
                      </MenuItem>
                      <MenuItem value={"Completed with Follow Up"}>
                        Completed with Follow Up
                      </MenuItem>
                      <MenuItem value={"Returned"}>Returned</MenuItem>
                      <MenuItem value={"On Hold"}>On Hold</MenuItem>
                      <MenuItem value={"Aborted"}>Aborted</MenuItem>
                      <MenuItem value={"ReAssigned"}>ReAssigned</MenuItem>
                      <MenuItem value={"Cancelled By Portal"}>
                        Cancelled By Portal
                      </MenuItem>
                      <MenuItem value={"Removed"}>Removed</MenuItem>
                      <MenuItem value={"Invoiced"}>Invoiced</MenuItem>
                      <MenuItem value={"Awaiting Payment"}>
                        Awaiting Payment
                      </MenuItem>
                      {/* <MenuItem value={"Awaiting Payment"}>Invoiced</MenuItem> */}
                    </Select>
                  </FormControl>

                  <FormControl
                    variant="outlined"
                    className={classes.selectFeild}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Page Size
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={this.state.pageSize}
                      name="pageSize"
                      onChange={this.handleChange}
                      label="Page Size"
                    >
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                      <MenuItem value={150}>150</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl
                    variant="outlined"
                    className={classes.selectFeild}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Sort By
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={this.state.sortBy}
                      name="sortBy"
                      onChange={this.handleChange}
                      label="sortBy"
                    >
                      <MenuItem value={"ref"}>Dyno Ref</MenuItem>
                      <MenuItem value={"priority"}>Priority</MenuItem>
                    </Select>
                  </FormControl>
                  {/* <TextField
                        value={this.state.vehicleRegNo}
                        name="vehicleRegNo"
                        label="Vehicle Reg No"
                        className={classes.textField}
                        margin="normal"
                        onChange={this.handleChange}
                        variant="outlined"
                        // error={errorFirstName}
                      /> */}

                  <Button
                    variant="contained"
                    className={classes.startAutoJob}
                    disabled={showCircularProgress}
                    onClick={() => this.searchJob()}
                  >
                    {showCircularProgress && (
                      <CircularProgress
                        size={20}
                        className={classes.circularProgress}
                      />
                    )}
                    Find Job
                  </Button>
                </Grid>
              </Grid>
              {/* </AccordionDetails>
              </Accordion> */}
            </Grid>

            <Grid
              className={classes.grid}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <div className={classes.tableHeading}>
                <Typography>Jobs</Typography>
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    onChange={(e) => this.handleSearch(e)}
                    placeholder="Search DYNO Ref… "
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    inputProps={{ "aria-label": "search" }}
                  />
                </div>
              </div>

              <TableContainer
                component={Paper}
                className={classes.tableContainer}
              >
                <Table
                  aria-label="custom pagination table"
                  className={classes.table}
                >
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      {tableColumns.map((column) => (
                        <TableCell
                          className={classes.tableHeadCol}
                          variant="head"
                          align="center"
                        >
                          {column.title}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {showCircularProgress && (
                    <div className={classes.tableHeadFull}>
                      <Grid
                        className={classes.grid}
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                      >
                        <CircularProgress
                          size={50}
                          className={classes.circularStyle}
                        />
                      </Grid>
                    </div>
                  )}
                  {!showCircularProgress && (
                    <TableBody className={classes.tableHead}>
                      {jobListFilteredData.map((row) => (
                        <TableRow
                        //   key={row.name}
                        >
                          {tableColumns.map((column) => (
                            <TableCell
                              // className={
                              //   isCellHovered == row.postCode + "-" + column.field &&
                              //   column.field !== "isEnabled" &&
                              //   column.field !== "currentlyPricing"
                              //     ? classes.tableRowHovered
                              //     : classes.tableRow
                              // }
                              // onMouseOver={() =>
                              //   cellHover(row.postCode + "-" + column.field)
                              // }
                              // onMouseLeave={() =>
                              //   cellLeave(row.postCode + "-" + column.field)
                              // }
                              component="th"
                              scope="row"
                              align="center"
                              // onClick={() => handleCellClick(row, column.field)}
                              // className={classes.tableBody}
                            >
                              {column.field === "status" ? (
                                <Chip
                                  size="small"
                                  style={
                                    row[column.field] === "Completed" ||
                                    row[column.field] ===
                                      "Completed and Signed Off" ||
                                    row[column.field] === "Invoiced" ||
                                    row[column.field] === "Received By Operator"
                                      ? {
                                          backgroundColor: "#e5f9ed",
                                          color: "#1bc943",
                                          fontWeight: 600,
                                          padding: "5px",
                                        }
                                      : row[column.field] === "Completed with Follow Up"
                                      ? {
                                          backgroundColor: "#e5f9ed",
                                          color: "#20B2AA",
                                          fontWeight: 600,
                                          padding: "5px",
                                        }
                                      :  row[column.field] ===
                                          "Cancelled By Portal" ||
                                        row[column.field] === "Aborted" ||
                                        row[column.field] === "Removed"
                                      ? {
                                          backgroundColor: "#fff5f6",
                                          color: "#f83245",
                                          fontWeight: 600,
                                          padding: "5px",
                                        }
                                      : row[column.field] === "Recorded" ||
                                        row[column.field] ===
                                          "Awaiting Operator Receipt" ||
                                        row[column.field] ===
                                          "Amendments Submitted" ||
                                        row[column.field] === "Returned"
                                      ? {
                                          backgroundColor: "#fff5f6",
                                          color: "#f15a2f",
                                          fontWeight: 600,
                                          padding: "5px",
                                        }
                                      : {
                                          backgroundColor: "#fff8e1",
                                          color: "#ffc107",
                                          fontWeight: 600,
                                          padding: "5px",
                                        }
                                  }
                                  label={row[column.field]}
                                  className={
                                    row[column.field] === true
                                      ? classes.enabledChip
                                      : classes.disabledChip
                                  }
                                />
                              ) : column.field === "jobID" ||
                                column.field === "customerName" ? (
                                <div className={classes.tableBold}>
                                  {row[column.field]}
                                </div>
                              ) : column.field === "deliveryDate" ? (
                                <div>
                                  {moment(row[column.field])
                                    .tz("Europe/London")
                                    .format("DD/MM/YYYY hh:mm A")}
                                </div>
                              ) : column.field === "deliveryBy" ? (
                                <div>{row[column.field]}</div>
                              ) : column.field === "action" ? (
                                <div className={classes.tableBold}>
                                  <LaunchIcon
                                    className={classes.launchIcon}
                                    onClick={(e) =>
                                      this.handleJobDetailView(row)
                                    }
                                  />
                                </div>
                              ) : (
                                <>{row[column.field]}</>
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                      {jobListFilteredData.length === 0 && (
                        <Typography
                          variant="h6"
                          component="h6"
                          className={classes.noDataFoundText}
                        >
                          No Data Found
                        </Typography>
                      )}
                    </TableBody>
                  )}

                  <TableFooter>
                    <TableRow></TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
              <div className={classes.tableFooter}>
                <Pagination
                  count={totalPages}
                  variant="outlined"
                  onChange={this.handlePageChange}
                />
              </div>
            </Grid>
          </>
        )}
        {jobDetailView && (
          <JobDetail
            selectedJob={selectedJob}
            allDrivers={allDrivers}
            jobDetailBack={this.jobDetailBack}
            showSnackBar={this.showSnackBar}
          />
        )}
        <ConfirmedSnackBar
          open={openSnackbar}
          message={snackBarMessage}
          handleClose={this.handleSnackBarClose}
          classes={classes}
        />
      </>
    );
  }
}

export default withStyles(styles)(JobList);
